import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import { Modal, Button } from "react-bootstrap";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import { getEstaciones } from "../helpers/rutaEstaciones";
import { getViajes } from "../helpers/rutaViajes";
import { getPagoEstaciones } from "../helpers/rutaPagoEstacion";
import { getSaldoInicialEstaciones } from "../helpers/rutaSaldoInicialEstacion";

import ModalSaldoInicialEstacion from "../components/ModalSaldoInicialEstacion";
import ModalPagoEstacion from "../components/ModalPagoEstacion";

import Table from "./TableContainer";
import "../css/tablecomandas.css";

const Styles = styled.div`
  .table-container {
    overflow: auto;
    height: 600px;
  }

  table {
    border: 1px solid black;
    border-spacing: 0;
    font-size: 13px;
  }

  th,
  td {
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  th {
    background-color: #778899;
    position: sticky;
    top: 0;
    z-index: 2;
    text-align: center;
    font-size: 12px;
  }

  td {
    background-color: white;
  }

  .pagination {
    padding: 0.5rem;
    background-color: #778899;
    font-size: 15px;
    font-weight: bold;
  }
`;

const FiltrosBar = styled.div`
  display: grid;

  grid-template-columns:
    120px
    120px
    minmax(220px, 1.5fr)
    130px
    110px
    130px
    1fr;

  gap: 10px;

  margin-bottom: 12px;

  align-items: end;

  padding: 14px;

  border: 1px solid #e2e8f0;
  border-radius: 12px;

  background: #ffffff;

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .field {
    display: flex;
    flex-direction: column;

    min-width: 0;
  }

  label {
    margin-bottom: 5px;

    color: #59687d;

    font-size: 10px;
    font-weight: 600;

    white-space: nowrap;
  }

  input,
  select {
    width: 100%;
    height: 34px;

    box-sizing: border-box;

    padding: 0 8px;

    border: 1px solid #d7e0ea;
    border-radius: 7px;

    background: #ffffff;

    color: #24324a;

    font-size: 10.5px;

    outline: none;
  }

  input:focus,
  select:focus {
    border-color: #80a9dc;

    box-shadow:
      0 0 0 2px
      rgba(40, 104, 198, 0.07);
  }

  .detalle {
    grid-column: 1 / span 3;
  }

  .btns {
    grid-column: 4 / -1;

    display: flex;
    align-items: end;

    gap: 6px;

    flex-wrap: nowrap;
  }

  .btns button {
    min-width: 115px;
    height: 34px;

    padding: 5px 9px;

    border-radius: 7px;

    font-size: 10px;

    white-space: nowrap;
  }

  @media (max-width: 1200px) {
    grid-template-columns:
      repeat(4, minmax(120px, 1fr));

    .detalle {
      grid-column: span 2;
    }

    .btns {
      grid-column: 1 / -1;

      flex-wrap: wrap;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns:
      1fr 1fr;

    .detalle,
    .btns {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;

    .detalle,
    .btns {
      grid-column: 1;
    }

    .btns {
      flex-direction: column;

      align-items: stretch;
    }

    .btns button {
      width: 100%;
    }
  }
`;

const ResumenBar = styled.div`
  display: grid;

  grid-template-columns:
    repeat(5, minmax(0, 1fr));

  gap: 9px;

  margin-bottom: 12px;

  .card-resumen {
    min-height: 72px;

    padding: 10px 11px;

    border: 1px solid #e1e8f0;
    border-radius: 10px;

    background: #ffffff;

    box-shadow:
      0 3px 12px
      rgba(15, 23, 42, 0.035);

    transition:
      transform 0.15s ease,
      box-shadow 0.15s ease;
  }

  .card-resumen:hover {
    transform: translateY(-1px);

    box-shadow:
      0 5px 14px
      rgba(15, 23, 42, 0.055);
  }

  .titulo {
    margin-bottom: 5px;

    color: #738197;

    font-size: 9.5px;
    font-weight: 600;
  }

  .valor {
    color: #1e2d44;

    font-size: 17px;
    font-weight: 700;

    white-space: nowrap;

    font-variant-numeric:
      tabular-nums;
  }

  @media (max-width: 1000px) {
    grid-template-columns:
      repeat(3, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns:
      1fr;
  }
`;

const InformeEstacionesHeader = styled.div`
  display: flex;
  align-items: center;

  min-height: 78px;

  margin-bottom: 12px;

  padding: 14px 18px;

  border: 1px solid #dce5f0;
  border-radius: 14px;

  background:
    linear-gradient(
      120deg,
      #ffffff 0%,
      #f8fafc 65%,
      #eef4fb 100%
    );

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .header-icon {
    width: 46px;
    height: 46px;

    flex: 0 0 46px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 11px;

    background: #eaf2ff;

    color: #2868c6;

    font-size: 19px;
  }

  .header-text span {
    display: block;

    margin-bottom: 2px;

    color: #5f7fa8;

    font-size: 9px;
    font-weight: 700;

    letter-spacing: 1.7px;
  }

  .header-text h3 {
    margin: 0 0 3px 0;

    color: #18243a;

    font-size: 20px;
    font-weight: 700;
  }

  .header-text p {
    margin: 0;

    color: #748196;

    font-size: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px;

    .header-icon {
      width: 42px;
      height: 42px;

      flex-basis: 42px;
    }

    .header-text h3 {
      font-size: 17px;
    }
  }
`;

function toStartOfDay(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T00:00:00`);
  return isNaN(d) ? null : d;
}

function toEndOfDay(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T23:59:59`);
  return isNaN(d) ? null : d;
}

const num = (v) => Number(v || 0) || 0;

const $ = (n) =>
  num(n).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const norm = (v) =>
  String(v || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

function getId(v) {
  if (!v) return "";
  if (typeof v === "string") return v;
  if (v?.$oid) return v.$oid;
  if (typeof v?._id === "string") return v._id;
  if (v?._id?.$oid) return v._id.$oid;
  if (typeof v?.id === "string") return v.id;
  return "";
}

function getDateValue(v) {
  if (!v) return "";
  if (typeof v === "string") return v;
  if (v?.$date) return v.$date;
  return "";
}

function dateOnly(value) {
  const raw = getDateValue(value) || value;
  if (!raw) return "";

  const s = String(raw).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";

  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
}

function parseDateOnlyLocal(value) {
  const iso = dateOnly(value);
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

function formatFecha(value) {
  const iso = dateOnly(value);
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

function firstDayOfMonthISO() {
  const d = new Date();
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  local.setDate(1);
  return local.toISOString().slice(0, 10);
}

function todayISO() {
  const d = new Date();
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

const normalizarEstaciones = (resp) => {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.estaciones)) return resp.estaciones;
  if (Array.isArray(resp.data?.estaciones)) return resp.data.estaciones;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
};

const normalizarViajes = (resp) => {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.viajes)) return resp.viajes;
  if (Array.isArray(resp.data?.viajes)) return resp.data.viajes;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
};

const normalizarPagos = (resp) => {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.pagos)) return resp.pagos;
  if (Array.isArray(resp.data?.pagos)) return resp.data.pagos;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
};

const normalizarSaldos = (resp) => {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.saldos)) return resp.saldos;
  if (Array.isArray(resp.data?.saldos)) return resp.data.saldos;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
};

const getEstacionLabel = (e) =>
  [e?.estacion, e?.lugar].filter(Boolean).join(" - ").trim();

const esMetodoCuentaCorriente = (metodo) => {
  const m = String(metodo || "")
    .trim()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toUpperCase();

  return ["CTA. CTE.", "CTA CTE", "CTA.CTE.", "CUENTA CORRIENTE"].includes(m);
};

function ModalDetalleMovimiento({ show, handleClose, movimiento }) {
  if (!movimiento) return null;

  const totalAplicado = num(movimiento.totalaplicado ?? movimiento.pago);
  const saldoAFavor = num(movimiento.saldoafavor);

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Detalle</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-2">
          <strong>Fecha:</strong> {formatFecha(movimiento.fecha)}
        </div>
        <div className="mb-2">
          <strong>Tipo:</strong> {movimiento.tipomov}
        </div>
        <div className="mb-2">
          <strong>Estación:</strong> {movimiento.estacionLabel}
        </div>
        {movimiento.nroviaje ? (
          <div className="mb-2">
            <strong>Viaje:</strong> {movimiento.nroviaje}
          </div>
        ) : null}
        {movimiento.localidad ? (
          <div className="mb-2">
            <strong>Localidad:</strong> {movimiento.localidad}
          </div>
        ) : null}
        <div className="mb-2">
          <strong>Medio pago:</strong> {movimiento.mediopago || "-"}
        </div>
        <div className="mb-2">
          <strong>Debe:</strong> $ {$(movimiento.liquidacion)}
        </div>
        <div className="mb-2">
          <strong>Pago:</strong> $ {$(movimiento.pago)}
        </div>
        {movimiento.tipomov === "PAGO" && (
          <>
            <div className="mb-2">
              <strong>Total aplicado:</strong> $ {$(totalAplicado)}
            </div>
            <div className="mb-2">
              <strong>Saldo a favor generado:</strong>{" "}
              <span style={{ color: saldoAFavor > 0 ? "#0d6efd" : "#333" }}>
                $ {$(saldoAFavor)}
              </span>
            </div>
          </>
        )}
        <div className="mb-2">
          <strong>Detalle:</strong> {movimiento.detalle || "-"}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default function AppCtaCteEstacionReactTable() {
  const [estaciones, setEstaciones] = useState([]);
  const [viajes, setViajes] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [saldos, setSaldos] = useState([]);

  const [loading, setLoading] = useState(true);
  const [showPagoModal, setShowPagoModal] = useState(false);
  const [showSaldoModal, setShowSaldoModal] = useState(false);

  const [detalleMov, setDetalleMov] = useState(null);
  const [showDetalle, setShowDetalle] = useState(false);

  const [filtros, setFiltros] = useState({
    desde: firstDayOfMonthISO(),
    hasta: todayISO(),
    estacion: "",
    tipo: "",
    nroviaje: "",
    localidad: "",
    mediopago: "",
    detalle: "",
  });

  const exportarPDFEstacion = () => {
    const doc = new jsPDF("l", "mm", "a4");

    const estacionSel =
      estaciones.find((e) => getId(e) === filtros.estacion) || null;

    const nombreEstacion = filtros.estacion
      ? getEstacionLabel(estacionSel) || "Estación seleccionada"
      : "Todas las estaciones";

    const desdeTxt = filtros.desde || "-";
    const hastaTxt = filtros.hasta || "-";

    const saldoInicialEsAFavor = num(resumen.saldoInicial) < 0;
    const saldoFinalEsAFavor = num(resumen.saldoFinal) < 0;

    const tituloSaldoInicial = saldoInicialEsAFavor
      ? "Saldo inicial a favor"
      : "Saldo inicial";

    const tituloSaldoFinal = saldoFinalEsAFavor
      ? "Saldo a favor"
      : "Saldo final";

    const valorSaldoInicial = Math.abs(num(resumen.saldoInicial));
    const valorSaldoFinal = Math.abs(num(resumen.saldoFinal));

    doc.setFontSize(15);
    doc.text("CTA CTE ESTACIONES DE SERVICIO", 14, 14);

    doc.setFontSize(10);
    doc.text(`Estación: ${nombreEstacion}`, 14, 22);
    doc.text(`Desde: ${desdeTxt}`, 14, 28);
    doc.text(`Hasta: ${hastaTxt}`, 60, 28);

    doc.text(`${tituloSaldoInicial}: $ ${$(valorSaldoInicial)}`, 14, 36);
    doc.text(`Saldo inicial período: $ ${$(resumen.totalSaldoInicial)}`, 75, 36);
    doc.text(`Combustible período: $ ${$(resumen.totalCombustible)}`, 145, 36);
    doc.text(`Total pagado: $ ${$(resumen.totalPagado)}`, 215, 36);

    doc.setFontSize(11);
    doc.text(`${tituloSaldoFinal}: $ ${$(valorSaldoFinal)}`, 14, 43);

    const body = dataFiltrada.map((r) => [
      formatFecha(r.fecha),
      r.tipomov || "",
      r.estacionLabel || "",
      r.nroviaje || "",
      r.localidad || "",
      r.liquidacion ? `$ ${$(r.liquidacion)}` : "",
      r.pago ? `$ ${$(r.pago)}` : "",
      `$ ${$(r.saldoacumulado)}`,
      r.mediopago || "",
      r.detalle || "",
    ]);

    const head = [[
      "Fecha",
      "Tipo",
      "Estación",
      "Viaje",
      "Localidad",
      "Debe",
      "Pago",
      "Saldo Acum.",
      "Medio Pago",
      "Detalle",
    ]];

    autoTable(doc, {
      startY: 48,
      margin: { top: 6, right: 4, bottom: 8, left: 14 },
      theme: "grid",
      styles: {
        fontSize: 6.6,
        cellPadding: 1,
        overflow: "linebreak",
        valign: "middle",
        lineWidth: 0.1,
      },
      headStyles: {
        fontSize: 6.8,
        cellPadding: 1,
        halign: "center",
        valign: "middle",
      },
      bodyStyles: {
        fontSize: 6.4,
      },
      columnStyles: {
        0: { cellWidth: 16 },
        1: { cellWidth: 20 },
        2: { cellWidth: 44 },
        3: { cellWidth: 16, halign: "center" },
        4: { cellWidth: 24 },
        5: { cellWidth: 22, halign: "right" },
        6: { cellWidth: 22, halign: "right" },
        7: { cellWidth: 24, halign: "right" },
        8: { cellWidth: 22, halign: "center" },
        9: { cellWidth: 72 },
      },
      head,
      body,
      didParseCell: (data) => {
        if (data.section !== "body") return;

        const row = data.row.raw;
        if (!row) return;

        if (data.column.index === 5 && row[5]) {
          data.cell.styles.textColor = [25, 135, 84];
          data.cell.styles.fontStyle = "bold";
        }

        if (data.column.index === 6 && row[6]) {
          data.cell.styles.textColor = [13, 110, 253];
          data.cell.styles.fontStyle = "bold";
        }

        if (data.column.index === 7 && row[7]) {
          const saldoTexto = String(row[7] || "");
          const tieneNegativo = saldoTexto.includes("-");

          data.cell.styles.textColor = tieneNegativo
            ? [13, 110, 253]
            : [25, 135, 84];

          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    const nombreArchivo = `cta_cte_estacion_${nombreEstacion
      .replace(/\s+/g, "_")
      .replace(/[^\w\-]/g, "")
      .toLowerCase()}_${desdeTxt}_${hastaTxt}.pdf`;

    doc.save(nombreArchivo);
  };

  const setF = (k, v) => setFiltros((prev) => ({ ...prev, [k]: v }));

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const [respEstaciones, respViajes, respPagos, respSaldos] = await Promise.all([
        getEstaciones(),
        getViajes(),
        getPagoEstaciones(),
        getSaldoInicialEstaciones(),
      ]);

      setEstaciones(normalizarEstaciones(respEstaciones));
      setViajes(normalizarViajes(respViajes));
      setPagos(normalizarPagos(respPagos));
      setSaldos(normalizarSaldos(respSaldos));
    } catch (error) {
      console.error("Error al cargar cuenta corriente estaciones:", error);
      setEstaciones([]);
      setViajes([]);
      setPagos([]);
      setSaldos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const estacionMap = useMemo(() => {
    const map = {};
    (estaciones || []).forEach((e) => {
      map[getId(e)] = e;
    });
    return map;
  }, [estaciones]);

  const pagosActivos = useMemo(() => {
    return (pagos || []).filter((p) => p?.estado === "activo");
  }, [pagos]);

  const saldosActivos = useMemo(() => {
    return (saldos || []).filter((s) =>
      s?.estado ? s.estado === "activo" : true
    );
  }, [saldos]);

  const aplicadoCombustibleMap = useMemo(() => {
    const map = {};

    pagosActivos.forEach((p) => {
      (p.aplicaciones || []).forEach((a) => {
        if (a?.origenTipo !== "COMBUSTIBLE") return;
        const id = getId(a?.combustibleId) || String(a?.combustibleId || "");
        if (!id) return;
        map[id] = num(map[id]) + num(a?.montoaplicado);
      });
    });

    return map;
  }, [pagosActivos]);

  const aplicadoSaldoMap = useMemo(() => {
    const map = {};

    pagosActivos.forEach((p) => {
      (p.aplicaciones || []).forEach((a) => {
        if (a?.origenTipo !== "SALDO_INICIAL") return;
        const id = getId(a?.saldoInicialId) || String(a?.saldoInicialId || "");
        if (!id) return;
        map[id] = num(map[id]) + num(a?.montoaplicado);
      });
    });

    return map;
  }, [pagosActivos]);

  const movimientosBase = useMemo(() => {
    const rowsSaldos = saldosActivos.map((s) => {
      const estacionId = getId(s?.estacion);
      const estObj = estacionMap[estacionId] || s?.estacion || null;
      const monto = num(s?.monto);

      return {
        _id: `saldo-${getId(s)}`,
        idorigen: getId(s),
        tipomov: "SALDO_INICIAL",
        fecha: getDateValue(s?.fecha) || s?.fecha || s?.createdAt || "",
        estacionId,
        estacionLabel: getEstacionLabel(estObj),
        localidad: "",
        nroviaje: "",
        mediopago: "",
        liquidacion: monto,
        pago: 0,
        saldofila: monto - num(aplicadoSaldoMap[getId(s)]),
        detalle: s?.observaciones || "Saldo inicial",
      };
    });

    const rowsCombustible = [];

    (viajes || [])
      .filter((v) => (v?.estado ? v.estado === "activo" : true))
      .forEach((v) => {
        const nroviaje = Number(v?.nroViaje || v?.nroviaje || 0);

        (Array.isArray(v?.combustible) ? v.combustible : []).forEach((c) => {
          const estacionId = getId(c?.estacion);
          const combustibleId = getId(c);
          const monto = num(c?.monto);

          if (!estacionId || !combustibleId || monto <= 0) return;
          if (!esMetodoCuentaCorriente(c?.metodoPago)) return;

          const estObj = estacionMap[estacionId] || c?.estacion || null;

          rowsCombustible.push({
            _id: `comb-${combustibleId}`,
            idorigen: combustibleId,
            tipomov: "COMBUSTIBLE",
            fecha:
              getDateValue(c?.fecha) ||
              c?.fecha ||
              getDateValue(v?.fechaInicio) ||
              v?.fechaInicio ||
              v?.createdAt ||
              "",
            estacionId,
            estacionLabel: getEstacionLabel(estObj),
            localidad: c?.localidad || "",
            nroviaje,
            mediopago: c?.metodoPago || "",
            litros: num(c?.litros),
            liquidacion: monto,
            pago: 0,
            saldofila: monto - num(aplicadoCombustibleMap[combustibleId]),
            detalle: `Combustible viaje ${nroviaje}${c?.localidad ? ` - ${c.localidad}` : ""}`,
          });
        });
      });

    const rowsPagos = pagosActivos.map((p) => {
      const estacionId = getId(p?.estacion);
      const estObj = estacionMap[estacionId] || p?.estacion || null;

      const nroviajeTexto = Array.isArray(p?.aplicaciones)
        ? p.aplicaciones
            .map((a) => a?.nroviaje)
            .filter(Boolean)
            .join(", ")
        : "";

      const totalAplicado =
        p?.totalaplicado !== undefined
          ? num(p.totalaplicado)
          : (Array.isArray(p?.aplicaciones) ? p.aplicaciones : []).reduce(
              (acc, a) => acc + num(a?.montoaplicado),
              0
            );

      const saldoAFavor =
        p?.saldoafavor !== undefined
          ? num(p.saldoafavor)
          : Math.max(0, num(p?.montototal) - totalAplicado);

      const detalleBase =
        p?.observaciones ||
        `Pago ${p?.nropago || ""}${nroviajeTexto ? ` - viajes ${nroviajeTexto}` : ""}`;

      const detalle = [
        detalleBase,
        saldoAFavor > 0 ? `Saldo a favor $ ${$(saldoAFavor)}` : "",
      ]
        .filter(Boolean)
        .join(" - ");

      return {
        _id: `pago-${getId(p)}`,
        idorigen: getId(p),
        tipomov: "PAGO",
        fecha:
          getDateValue(p?.fechapago) ||
          p?.fechapago ||
          getDateValue(p?.createdAt) ||
          p?.createdAt ||
          "",
        estacionId,
        estacionLabel: getEstacionLabel(estObj),
        localidad: "",
        nroviaje: nroviajeTexto,
        mediopago: p?.mediopago || "",
        liquidacion: 0,
        pago: num(p?.montototal),
        totalaplicado: totalAplicado,
        saldoafavor: saldoAFavor,
        saldofila: 0,
        nropago: p?.nropago || "",
        detalle,
      };
    });

    return [...rowsSaldos, ...rowsCombustible, ...rowsPagos].sort((a, b) => {
      const fa = parseDateOnlyLocal(a.fecha)?.getTime() ?? 0;
      const fb = parseDateOnlyLocal(b.fecha)?.getTime() ?? 0;

      if (fa !== fb) return fa - fb;

      const orden = { SALDO_INICIAL: 1, COMBUSTIBLE: 2, PAGO: 3 };
      return (orden[a.tipomov] || 9) - (orden[b.tipomov] || 9);
    });
  }, [saldosActivos, viajes, pagosActivos, estacionMap, aplicadoSaldoMap, aplicadoCombustibleMap]);

  const movimientosEstacion = useMemo(() => {
    return movimientosBase.filter((r) => {
      if (filtros.estacion && r.estacionId !== filtros.estacion) return false;
      return true;
    });
  }, [movimientosBase, filtros.estacion]);

  const dDesde = toStartOfDay(filtros.desde);
  const dHasta = toEndOfDay(filtros.hasta);

  const saldoInicial = useMemo(() => {
    return movimientosEstacion.reduce((acc, r) => {
      const f = parseDateOnlyLocal(r.fecha);
      if (dDesde && f && f < dDesde) {
        return acc + num(r.liquidacion) - num(r.pago);
      }
      return acc;
    }, 0);
  }, [movimientosEstacion, dDesde]);

  const movimientosPeriodoConSaldo = useMemo(() => {
    let saldoAcum = saldoInicial;

    return movimientosEstacion
      .filter((r) => {
        const f = parseDateOnlyLocal(r.fecha);
        if (dDesde && (!f || f < dDesde)) return false;
        if (dHasta && (!f || f > dHasta)) return false;
        return true;
      })
      .map((r) => {
        saldoAcum += num(r.liquidacion) - num(r.pago);
        return {
          ...r,
          saldoacumulado: saldoAcum,
        };
      });
  }, [movimientosEstacion, dDesde, dHasta, saldoInicial]);

  const dataFiltrada = useMemo(() => {
    return movimientosPeriodoConSaldo.filter((r) => {
      if (filtros.tipo && !norm(r?.tipomov).includes(norm(filtros.tipo))) return false;
      if (filtros.nroviaje && !norm(r?.nroviaje).includes(norm(filtros.nroviaje))) return false;
      if (filtros.localidad && !norm(r?.localidad).includes(norm(filtros.localidad))) return false;
      if (filtros.mediopago && !norm(r?.mediopago).includes(norm(filtros.mediopago))) return false;

      const libre = [
        r?.detalle,
        r?.estacionLabel,
        r?.localidad,
      ]
        .filter(Boolean)
        .join(" ");

      if (filtros.detalle && !norm(libre).includes(norm(filtros.detalle))) return false;

      return true;
    });
  }, [movimientosPeriodoConSaldo, filtros]);

  const resumen = useMemo(() => {
    const totalSaldoInicial = movimientosPeriodoConSaldo
      .filter((r) => r.tipomov === "SALDO_INICIAL")
      .reduce((acc, r) => acc + num(r.liquidacion), 0);

    const totalCombustible = movimientosPeriodoConSaldo
      .filter((r) => r.tipomov === "COMBUSTIBLE")
      .reduce((acc, r) => acc + num(r.liquidacion), 0);

    const totalPagado = movimientosPeriodoConSaldo.reduce(
      (acc, r) => acc + num(r.pago),
      0
    );

    const saldoFinal = saldoInicial + totalSaldoInicial + totalCombustible - totalPagado;

    return {
      saldoInicial,
      totalSaldoInicial,
      totalCombustible,
      totalPagado,
      saldoFinal,
      cantidadMovs: movimientosPeriodoConSaldo.length,
    };
  }, [movimientosPeriodoConSaldo, saldoInicial]);

  const limpiarFiltros = () => {
    setFiltros({
      desde: firstDayOfMonthISO(),
      hasta: todayISO(),
      estacion: "",
      tipo: "",
      nroviaje: "",
      localidad: "",
      mediopago: "",
      detalle: "",
    });
  };

  const handleDetalle = (row) => {
    setDetalleMov(row);
    setShowDetalle(true);
  };

  const closeDetalle = () => {
    setDetalleMov(null);
    setShowDetalle(false);
  };

  const columns = useMemo(
    () => [
      {
        id: "ver",
        Header: "Ver",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--edit"
            title="Ver detalle"
            onClick={() => handleDetalle(row.original)}
          >
            <i className="fa fa-search" aria-hidden="true" />
          </button>
        ),
      },
      {
        Header: "Tipo",
        accessor: "tipomov",
        width: 120,
      },
      {
        Header: "Fecha",
        accessor: (row) => dateOnly(row.fecha),
        id: "fecha",
        width: 95,
        Cell: ({ value }) => formatFecha(value),
      },
      {
        Header: "Estación",
        accessor: "estacionLabel",
        width: 240,
      },
      {
        Header: "Viaje",
        accessor: "nroviaje",
        width: 90,
      },
      {
        Header: "Localidad",
        accessor: "localidad",
        width: 160,
      },
      {
        Header: "Debe",
        accessor: "liquidacion",
        width: 130,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right", color: "#198754", fontWeight: "bold" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: (info) => {
          const total = info.rows.reduce(
            (acc, row) => acc + num(row.values.liquidacion),
            0
          );

          return (
            <div style={{ textAlign: "right", color: "#198754", fontWeight: "bold" }}>
              $ {$(total)}
            </div>
          );
        },
      },
      {
        Header: "Pago",
        accessor: "pago",
        width: 130,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right", color: "#0d6efd", fontWeight: "bold" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: (info) => {
          const total = info.rows.reduce(
            (acc, row) => acc + num(row.values.pago),
            0
          );

          return (
            <div style={{ textAlign: "right", color: "#0d6efd", fontWeight: "bold" }}>
              $ {$(total)}
            </div>
          );
        },
      },
      {
        Header: "Saldo Acum.",
        accessor: "saldoacumulado",
        width: 140,
        Cell: ({ value }) => (
          <div
            style={{
              textAlign: "right",
              fontWeight: "bold",
              color: num(value) >= 0 ? "#198754" : "#0d6efd",
            }}
          >
            $ {$(value)}
          </div>
        ),
        Footer: (info) => {
          const saldoFinalVisible = info.rows.length
            ? num(info.rows[info.rows.length - 1].values.saldoacumulado)
            : 0;

          return (
            <div
              style={{
                textAlign: "right",
                fontWeight: "bold",
                color: saldoFinalVisible >= 0 ? "#198754" : "#0d6efd",
              }}
            >
              $ {$(saldoFinalVisible)}
            </div>
          );
        },
      },
      {
        Header: "Medio Pago",
        accessor: "mediopago",
        width: 120,
      },
      {
        Header: "Nro Pago",
        accessor: "nropago",
        width: 80,
      },
      {
        Header: "Detalle",
        accessor: "detalle",
        width: 420,
      },
    ],
    []
  );

  const saldoAnteriorEsAFavor = resumen.saldoInicial < 0;
  const saldoFinalEsAFavor = resumen.saldoFinal < 0;

  const tituloSaldoAnterior = saldoAnteriorEsAFavor
    ? "Saldo anterior a favor"
    : "Saldo anterior";

  const tituloSaldoFinal = saldoFinalEsAFavor
    ? "Saldo a favor"
    : "Saldo final";

  const valorSaldoAnterior = Math.abs(resumen.saldoInicial);
  const valorSaldoFinal = Math.abs(resumen.saldoFinal);

  return (
    <div className="container mt-4">

      <InformeEstacionesHeader>
        <div className="header-icon">
          <i
            className="fa fa-tint"
            aria-hidden="true"
          />
        </div>

        <div className="header-text">
          <span>
            INFORMES
          </span>

          <h3>
            Cuenta Corriente de Estaciones
          </h3>

          <p>
            Consumos de combustible, pagos,
            saldos iniciales y movimientos
            por estación de servicio.
          </p>
        </div>
      </InformeEstacionesHeader>

      <FiltrosBar>
        <div className="field">
          <label>Fecha desde</label>
          <input
            type="date"
            value={filtros.desde}
            onChange={(e) => setF("desde", e.target.value)}
          />
        </div>

        <div className="field">
          <label>Fecha hasta</label>
          <input
            type="date"
            value={filtros.hasta}
            onChange={(e) => setF("hasta", e.target.value)}
          />
        </div>

        <div className="field">
          <label>Estación</label>
          <select
            value={filtros.estacion}
            onChange={(e) => setF("estacion", e.target.value)}
          >
            <option value="">Todas</option>
            {estaciones
              .filter((e) => e?.activo !== false)
              .sort((a, b) =>
                getEstacionLabel(a).localeCompare(getEstacionLabel(b), "es", {
                  sensitivity: "base",
                })
              )
              .map((e) => (
                <option key={getId(e)} value={getId(e)}>
                  {getEstacionLabel(e)}
                </option>
              ))}
          </select>
        </div>

        <div className="field">
          <label>Tipo</label>
          <select
            value={filtros.tipo}
            onChange={(e) => setF("tipo", e.target.value)}
          >
            <option value="">Todos</option>
            <option value="SALDO_INICIAL">SALDO_INICIAL</option>
            <option value="COMBUSTIBLE">COMBUSTIBLE</option>
            <option value="PAGO">PAGO</option>
          </select>
        </div>

        <div className="field">
          <label>Nro Viaje</label>
          <input
            value={filtros.nroviaje}
            onChange={(e) => setF("nroviaje", e.target.value)}
          />
        </div>

        <div className="field">
          <label>Localidad</label>
          <input
            value={filtros.localidad}
            onChange={(e) => setF("localidad", e.target.value)}
          />
        </div>

        <div className="field">
          <label>Medio pago</label>
          <input
            value={filtros.mediopago}
            onChange={(e) => setF("mediopago", e.target.value)}
          />
        </div>

        <div className="field detalle">
          <label>Detalle</label>
          <input
            value={filtros.detalle}
            onChange={(e) => setF("detalle", e.target.value)}
          />
        </div>

        <div className="btns">
          <button
            type="button"
            className="btn btn-outline-dark btn-sm"
            onClick={limpiarFiltros}
          >
            Limpiar
          </button>

          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => setShowSaldoModal(true)}
          >
            Saldo Inicial
          </button>

          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={() => setShowPagoModal(true)}
          >
            Registrar Pago
          </button>

          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={exportarPDFEstacion}
          >
            Exportar PDF
          </button>
        </div>
      </FiltrosBar>

      <ResumenBar>
        <div className="card-resumen">
          <div className="titulo">{tituloSaldoAnterior}</div>
          <div
            className="valor"
            style={{ color: saldoAnteriorEsAFavor ? "#0d6efd" : "#198754" }}
          >
            $ {$(valorSaldoAnterior)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Saldo inicial período</div>
          <div className="valor" style={{ color: "#198754" }}>
            $ {$(resumen.totalSaldoInicial)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Combustible período</div>
          <div className="valor" style={{ color: "#198754" }}>
            $ {$(resumen.totalCombustible)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Total pagado</div>
          <div className="valor" style={{ color: "#0d6efd" }}>
            $ {$(resumen.totalPagado)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">{tituloSaldoFinal}</div>
          <div
            className="valor"
            style={{ color: saldoFinalEsAFavor ? "#0d6efd" : "#198754" }}
          >
            $ {$(valorSaldoFinal)}
          </div>
        </div>
      </ResumenBar>

      <Styles>
        <div className="table-container">
          <Table
            columns={columns}
            data={dataFiltrada}
            loading={loading}
            plugins={[useFilters, useSortBy, usePagination]}
          />
        </div>
      </Styles>

      {showPagoModal && (
        <ModalPagoEstacion
          show={showPagoModal}
          setShow={setShowPagoModal}
          onGuardado={fetchData}
        />
      )}

      {showSaldoModal && (
        <ModalSaldoInicialEstacion
          show={showSaldoModal}
          setShow={setShowSaldoModal}
          onGuardado={fetchData}
        />
      )}

      {detalleMov && (
        <ModalDetalleMovimiento
          show={showDetalle}
          handleClose={closeDetalle}
          movimiento={detalleMov}
        />
      )}
    </div>
  );
}